<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<div style="background-color: #ebebeb">
		<!-- <h4 class="FullWidth" style="text-align: center;">Substitutes</h4> -->

		<!--Options Grid-->
		<div class="OptionsGrid">
			<label>School:</label>
			<caass-schoolselector [ShowAll]="false" [Disabled]="IsLoading()"> </caass-schoolselector>

			<label>Person Type:</label>
			<select
				[disabled]="IsLoading() == true"
				class="form-control"
				name="PersonTypeID"
				[(ngModel)]="PersonTypeID"
				(ngModelChange)="onPersonTypeChange($event)"
			>
				<option *ngFor="let o of lstPersonType" [ngValue]="o.PersonTypeID">
					{{ o.PersonTypeDesc }}
				</option>
			</select>

			<label>Subbing Today:</label>
			<select
				[disabled]="IsLoading() == true"
				class="form-control"
				name="IsSubbingToday"
				[(ngModel)]="IsSubbingToday"
				(ngModelChange)="onSubbingTodayChange($event)"
			>
				<option *ngFor="let o of lstSubbingToday" [ngValue]="o.ID">
					{{ o.Desc }}
				</option>
			</select>

			<label>Active:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="ActiveID" [(ngModel)]="ActiveID" (ngModelChange)="onActiveChange($event)">
				<option *ngFor="let o of lstActive" [ngValue]="o.ID">
					{{ o.Desc }}
				</option>
			</select>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAddSubPerson()">Create Sub Account</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAssignSub()">Edit Assignments</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onToggleSub()">Toggle Sub</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPerson"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPerson"
		dataKey="PersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--UserName-->
				<th>
					<p-columnFilter type="text" field="UserName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SubbingForDesc-->
				<th>
					<!-- <p-columnFilter field="SubbingForDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterSubbingForDesc [ngModel]="value" [options]="lstSubbingForDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->

					<p-columnFilter type="text" field="SubbingForDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PersonTypeDesc-->
				<th>
					<p-columnFilter field="PersonTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPersonTypeDesc
								[ngModel]="value"
								[options]="lstPersonTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="UserName">Username(s)<p-sortIcon field="UserName"></p-sortIcon></th>
				<th pSortableColumn="SubbingForDesc">Subbing For<p-sortIcon field="SubbingForDesc"></p-sortIcon></th>
				<th pSortableColumn="PersonTypeDesc">Person Type<p-sortIcon field="PersonTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr [pSelectableRow]="Person" (dblclick)="onRowDblClick(Person)">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Person.Active == 1 ? 'Black' : 'Red'">
					{{ Person["ActiveDesc"] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
